export default __webpack_public_path__ + "static/media/SB.c40fc3f7.svg";